import mixins from 'vue-typed-mixins';
import _ from 'lodash';

import RoutesMixin from '@/user/mixins/RoutesMixin';
import Calc from '@/user/pages/authorized/study/calc/Calc.vue';
import Japanese from '@/user/pages/authorized/study/japanese/Japanese.vue';
import Number from '@/user/pages/authorized/study/number/Number.vue';
import Word from '@/user/pages/authorized/study/word/Word.vue';




export default mixins(RoutesMixin).extend({

  name: 'Study',

  components: {
    Calc,
    Japanese,
    Number,
    Word,
  },

  computed: {
    courseComponent(): string {
      return _.capitalize(this.$route.params.courseId);
    }
  },

});
